module.exports = __webpack_public_path__ + "img/banner-cna.b09eb01b.png";